/* eslint-disable no-undef */
/* eslint-disable object-shorthand */
import axios from "axios";

export const getCep = cep => axios.get(`https://viacep.com.br/ws/${cep}/json/`);
